import React, { useEffect, useRef, useState } from "react";

import axios from "axios";

import { Button, SelectBox } from "devextreme-react";
import Box, { Item } from "devextreme-react/box";
import SponsorDistribution from "./Distribution";
import PhaseDistribution from "./PhaseDistribution";
import CumulativeDistributionByYear from "./CumulativeDistributionByYear";
import SiteNInvestigator from "./SiteNInvestigator";
// import SiteDistribution from "./SiteDistribution";
import Distribution from "./Distribution";
import MdcinClincTestInfoService01 from "../MdcinClincTestInfoService01";
import MdcinClincTestInfoService01Grid from "../MdcinClincTestInfoService01/MdcinClincTestInfoService01Grid";
import CustomStore from "devextreme/data/custom_store";
import { paletteCollection } from "./data";
import DataSource from "devextreme/data/data_source";
import Header from "../../common/Header";

export default function Indication() {
  const [dataSource, setDataSource] = useState(null);
  const [indication, setIndication] = useState(null);

  const [palette, setPalette] = useState("Material");

  useEffect(() => {
    document.title = "적응증별 임상시험 현황";

    axios
      .get(
        `${process.env.REACT_APP_BECCO_API_URL}/api/mdcinClincTestInfoService01/INDICATION`
      )
      .then((result) => {
        // setDataSource(result.data);
        setDataSource(
          new DataSource({
            store: result.data,
            type: "array",
            key: "TRGT_DISS_CD_NM",
          })
        );
      });
  }, []);

  const onIndicationValueChanged = ({ component }) => {
    setIndication(component.option("selectedItem").TRGT_DISS_CD_NM);
  };

  const onPaletteValueChanged = (e) => {
    setPalette(e.value);
  };

  const onCustomItemCreating = (args) => {
    if (!args.text) {
      args.customItem = null;

      return;
    }

    const newItem = {
      TRGT_DISS_CD_NM: args.text,
    };

    args.customItem = dataSource
      .store()
      .insert(newItem)
      .then(() => dataSource.load())
      .then(() => newItem)
      .catch((error) => {
        throw error;
      });

    // args.customItem = dataSource
    //   .store()
    //   .insert({
    //     TRGT_DISS_CD_NM: args.text,
    //   })
    //   .then(() => {
    //     data;
    //   });
  };

  return (
    <React.Fragment>
      {/* <h1
        style={{
          color: "#1B4452",
          marginBlockStart: "0.67em",
          marginBlockEnd: "0.67em",
          marginInlineStart: "0px",
          marginInlineEnd: "0px",
        }}
      >
        Clinical Trial Status by Indication
      </h1> */}
      <Header
        title={"CLINICAL TRIAL STATUS BY INDICATION"}
        menuDataSource={null}
      />
      <Box direction="row" width={"100%"}>
        <Item ratio={5}>
          <div className="widget-container">
            <div className="dx-fieldset">
              <div className="dx-field">
                <div className="dx-field-label" style={{ width: "auto" }}>
                  Indication
                </div>
                <div className="dx-field-value" style={{ width: "auto" }}>
                  <SelectBox
                    dataSource={dataSource}
                    displayExpr="TRGT_DISS_CD_NM"
                    searchMode="contains"
                    searchExpr={["TRGT_DISS_CD_NM"]}
                    searchEnabled={true}
                    searchTimeout={200}
                    minSearchLength={0}
                    // showDataBeforeSearch={false}
                    acceptCustomValue={true}
                    onValueChanged={onIndicationValueChanged}
                    onCustomItemCreating={onCustomItemCreating}
                  />
                </div>
              </div>
            </div>
          </div>
        </Item>
        <Item ratio={1}>
          <div className="widget-container">
            <div className="dx-fieldset">
              <div className="dx-field">
                <div className="dx-field-label" style={{ width: "auto" }}>
                  Palette
                </div>
                <div className="dx-field-value" style={{ width: "auto" }}>
                  <SelectBox
                    items={paletteCollection}
                    defaultValue={palette}
                    onValueChanged={onPaletteValueChanged}
                  />
                </div>
              </div>
            </div>
          </div>
        </Item>
      </Box>
      <Box direction="row" width="100%">
        <Item ratio={1}>
          <Distribution
            url="/api/mdcinClincTestInfoService01/SPONSOR/TOP10"
            title="Sponsor TOP 10"
            argumentField="APPLY_ENTP_NAME"
            indication={indication}
            palette={palette}
          />
        </Item>
        <Item ratio={1}>
          <Distribution
            url="/api/clinicTestOprtnInsttInfoService01/TOP10"
            title="Site TOP 10"
            argumentField="NAME"
            indication={indication}
            palette={palette}
          />
        </Item>
        <Item ratio={1}>
          <Distribution
            url="/api/clinicTestOprtnInsttInfoService01/byInvestigator/TOP10"
            title="Investigator TOP 10"
            argumentField="NAME"
            indication={indication}
            palette={palette}
          />
        </Item>
      </Box>
      <Box direction="row" width="100%">
        <Item ratio={1}>
          <PhaseDistribution indication={indication} palette={palette} />
        </Item>
        <Item ratio={1}>
          <CumulativeDistributionByYear
            indication={indication}
            palette={palette}
          />
        </Item>
        <Item ratio={1}></Item>
      </Box>
      <h2
        style={{
          color: "#1B4452",
          marginBlockStart: "0.67em",
          marginBlockEnd: "0.67em",
          marginInlineStart: "0px",
          marginInlineEnd: "0px",
        }}
      >
        Clinical Trials
      </h2>
      <MdcinClincTestInfoService01Grid indication={indication} />
      <h2
        style={{
          color: "#1B4452",
          marginBlockStart: "0.67em",
          marginBlockEnd: "0.67em",
          marginInlineStart: "0px",
          marginInlineEnd: "0px",
        }}
      >
        Site / Investigator
      </h2>
      <SiteNInvestigator indication={indication} />
    </React.Fragment>
  );
}
